import dayjs from 'dayjs'

export const ORDER_CUTOFFS = {
  BREAKFAST: '05:00:00',
  LUNCH: '07:00:00',
  SNACK: '07:00:00',
  DINNER: '10:00:00',
}

export function isMealLockedByCutoff(dateValue, meal, now = dayjs()) {
  const selected = dayjs(dateValue)

  if (selected.isBefore(now, 'day')) return true
  if (selected.isAfter(now, 'day')) return false

  const cutoff = ORDER_CUTOFFS[meal]
  if (!cutoff) return false

  const [hour, minute, second] = cutoff.split(':').map(Number)
  const cutoffTime = selected.hour(hour).minute(minute).second(second).millisecond(0)

  return !now.isBefore(cutoffTime)
}

export function isOrderCommentLocked(dateValue, now = dayjs()) {
  return isMealLockedByCutoff(dateValue, 'BREAKFAST', now)
}
